<template>
	<div class="col-sm-3 p-0 rounded relative">
		<div
			class="px-3 pb-2 pt-2 order-summary-wrapper"
		>
			<span>
				<b>Order Summary</b>
			</span>

			<div class="d-flex justify-content-between mt-3">
				<div>
					<small> {{ setFormatDate(data.created_at) }}</small>
				</div>
				<div>
					<i class="bi bi-calendar-week"></i>
				</div>
			</div>

			<div class="box-detail">
				<div class="mt-3 border p-2 box mx-auto">
					<div v-if="data.product_data" class="d-flex justify-content-between">
						<div>
							<small>{{ data.product_data.name || '-' }}</small>
						</div>
						<div>
							<small>(x{{ quantity || 0 }}) {{ formatMoney(data.product_price * quantity) || 0 }}</small>
						</div>
					</div>
					<hr />
					<div class="d-flex justify-content-between">
						<div>
							<small><b>Total</b></small>
						</div>
						<div>
							<small>{{formatMoney(data.product_price * quantity) || 0}}</small>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import { formatMoney } from '@/lib/helper';

export default {
	name: 'OrderSummary',
	props: {
		data: {
			type: Object,
			default: () => {},
		},
		quantity: {
			default: 0,
		},
	},
	methods: {
		formatMoney,
		setFormatDate(date) {
			return dayjs(date).format('dddd, DD-MMMM-YYYY');
		},

	},
};
</script>

<style lang="scss" scoped>
.order-summary-wrapper {
	border-left: 1px solid #dddd;
	border-right: 1px solid #ddd;
	border-top: 1px solid #ddd;
	border-bottom: 1px solid #ddd;
	box-shadow: #ddd;
	height: auto;
}

.box-detail {
	max-width: 200px;
}
</style>
